export default __webpack_public_path__ + "static/media/05.2c16329b.jpg";